import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { AuthService } from "../../../../services/AuthService";
import { useStore } from "store/context";

import Icon from "../../atoms/Icon/icon";
import imageFileWhite from "../../../../assets/images/logo blanco.png";
import logoCompleto from "assets/images/Logo.svg";
import { isMobile } from "helpers/Mobile";
import data from "./data";

import styles from "./MainApp.layouts.Sidebar.module.scss";
import NotificationAlert from "components/MainApp/atoms/NotificationAlert/NotificationAlert";
import i18n from "i18n";



export const Sidebar = () => {
  const [{ alert }] = useStore();
  
  const [expanded, setExpanded] = useState(false);
  const homeLogo = expanded ? logoCompleto : imageFileWhite;
const cachedPermissions = AuthService.getPermissions();
  /*useEffect(() => {
    setPermissions(AuthService.getPermissions());
  }, []);*/

  const renderItem = item => {
    if (isMobile && !item.mobile) return;

    const isActive = () =>
      item.activePaths.find(path => window.location.pathname.startsWith(path)) ||
      window.location.pathname === item.to

    return (
      <NavLink
        className={`${styles["item"]} ${expanded ? styles["expanded"] : ""}`}
        activeClassName={styles["active-item"]}
        to={item.to}
        key={item.to}
        isActive={item.activePaths && isActive}
      >
        <Icon
          name={item.icon}
          fill={isMobile ? "#0000003d" : "#FFFFFF"}
          className={`${item.icon} ${styles["section-icon"]}`}
        />
        <div className={`${styles["item-title"]} ${expanded ? styles["expanded"] : ""}`}>
          {item.title}
        </div>
        <div className={styles["inner-sep"]}></div>
      </NavLink>
    );
  };

  const mobileHome = (
    <NavLink
      className={`${styles["item"]} ${expanded ? styles["expanded"] : ""}`}
      activeClassName={styles["active-item"]}
      to="/admin/dashboard"
    >
      <Icon
        name={"yax"}
        className={styles["yax"]}
        fill={isMobile ? "#0000003d" : "#FFFFFF"}
      ></Icon>
      <div className={styles["inner-sep"]}></div>
    </NavLink>
  );

  return (
    <>
      <NotificationAlert alert={alert} expandedSidebar={expanded} />
      <div className={`${styles["sidebar-container"]} ${expanded ? styles["expanded"] : ""}`}>
        {!isMobile &&
        <NavLink
        className={`${styles["item"]} ${styles["home"]} ${expanded ? styles["expanded"] : ""}`}
        to="/admin/dashboard"
        activeClassName={styles["active-home"]}
        >
          <div className={`${styles["nav-icon"]} ${expanded ? styles["expanded"] : ""}`}>
            <img src={homeLogo} alt="logo" />
          </div>
        </NavLink>
      }
        {isMobile && mobileHome}
        {data
          .filter(i => {
            return cachedPermissions.includes(i.permission) || i.permission === "all";
          })
          .map(item => renderItem(item))}
        {!isMobile && (
          <div
          className={`${styles["item"]} ${expanded ? styles["expanded"] : ""}`}
          activeClassName={styles["active-item"]}
          to="/admin/account"
          onClick={() => AuthService.logout()}
          >
            <Icon
              name="cerrar-sesion"
              fill={"#FFFFFF"}
              width={isMobile ? 26 : 28}
              height={28}
              ></Icon>
            <div className={`${styles["item-title"]} ${expanded ? styles["expanded"] : ""}`}>
              {i18n.t("sign.out")}
            </div>
            <div className={styles["inner-sep"]}></div>
          </div>
        )}

        <div className={styles["sidebar-toggle"]} onClick={() => setExpanded(!expanded)}>
          <i
            className={`icon ${expanded ? "icon-chevron-izquierda" : "icon-chevron-derecha"} ${styles["icon"]}`}
          />
        </div>
      </div>
    </>
  );
};

Sidebar.propTypes = {};

export default Sidebar;
